import clsx from "clsx";
import { ReactNode } from "react";

import Spinner from "~/components/ui/spinner/Spinner";

import styles from "./PendingStatus.module.scss";

/** A spinner and what's being waited on, in place of an action. */
const PendingStatus = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <span className={clsx(styles.status, className)} role="status">
    <Spinner size="1rem" className={styles.spinner} />
    {children}
  </span>
);

export default PendingStatus;
